module.exports = __webpack_public_path__ + "img/img_6.0b18f16b.png";